import React from 'react';
import AppNoticeComposer from '../../components/appNotice/AppNoticeComposer';
import PushComposer from '../../components/appNotice/PushComposer';
import { NoticesTabs } from '../../components/appNotice/noticesUi';

/**
 * MARKETING › APP NOTICES — two surfaces on one key (design_handoff_app_notices):
 *   SHEETS  the in-app announcement (bottom sheet / card) with an audience + geofence
 *   PUSH    custom push notifications with an image, sent by a superadmin
 * Each composer draws the hero (its status pill and actions are the composer's own state)
 * and takes the tab bar to place under it.
 */
export default function NoticesPage({ view = 'sheets' }) {
  const tabs = <NoticesTabs view={view} />;
  return view === 'push' ? <PushComposer tabs={tabs} /> : <AppNoticeComposer tabs={tabs} />;
}
